<template >
  <transition appear type="animation" enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div>
      <Loading v-if="isLoading" :loadingText="'Carregando conteúdo exclusivo...'"></Loading>

      <div class="pb-4" v-if="!isLoading && (isSuperAdmin || segmentUsers || segmentAdmin)">
        <HeaderSistema :title="'Conteúdo Exclusivo'"></HeaderSistema>
        <BreadSistema></BreadSistema>

        <b-container fluid="lg">
          <b-card no-body class="p-4 shadow-sm card_sistemacpv">
            <b-row no-gutters>
              <b-col
                cols="12"
                md="6"
                lg="4"
                xl="3"
                class="pl-1 pr-1"
                v-for="(boxExclusivo, index) in objectBox.data.contents"
                :key="index.title"
              >
                <router-link :to="{ name: boxExclusivo.link_name }">
                  <b-card
                    class="card-link shadow-sm border-0 text-white"
                    :style="boxExclusivo.colorCard"
                    :class="boxExclusivo.bg__link"
                  >
                    <p class="text-center text-white"><i :class="boxExclusivo.iconClass"></i></p>
                    <h6 class="text-center text-white text-uppercase">{{ boxExclusivo.title }}</h6>
                    <div class="corner text-white d-none d-lg-flex">
                      <div class="arrow">
                        <i class="fa-solid fa-arrow-right"></i>
                      </div>
                    </div>
                  </b-card>
                </router-link>
              </b-col>
            </b-row>
          </b-card>
        </b-container>
      </div>
      <div v-else>
        <p class="display-3 text-center">
          <i class="fa-regular fa-face-frown"></i>
          <span class="d-block h2 font-weight-bolder">Desculpe...</span>
        </p>
        <p class="text-center font-weight-bolder">Contate o suporte para verificar seu acesso.</p>
      </div>
    </div>
  </transition>
</template>

<script>
  import ApiService from '@/common/api.service';
  import { getUserPermissions } from '@/common/jwt.service';
  import Loading from '@/components/loading.vue';

  export default {
    name: 'conteudo-exclusivo',
    components: {
      HeaderSistema: () => import('@/components/GlobalComponents/jumbotron-header'),
      BreadSistema: () => import('@/components/GlobalComponents/bread-sistema'),
      Loading
    },
    data() {
      return {
        pageTitle: 'Conteúdo Exclusivo',
        pageSubtitle: '',
        objectBox: {
          data: []
        },
        isReady: false,
        isLoading: true,
        permissoes: []
      };
    },

    created() {
      this.$emit('update-header', {
        title: this.pageTitle,
        subtitle: this.pageSubtitle
      });

      // this.postData()
    },
    watch: {
      '$store.state.auth.userpermissions.permissions': function(newValue, oldValue) {
        if (oldValue.length > 0) {
          this.isReady = true;
        }

        if (newValue.length > 0) {
          this.isReady = true;
        }
      },
      permissions: {
        immediate: true,
        handler(newPermissions) {
          if (newPermissions.length > 0) {
            this.isReady = true;
          }
        }
      },
      isReady: {
        immediate: true,
        handler(newIsReady) {
          if (newIsReady) {
            this.postData();
          }
        }
      },
      permissoes: function(newValue) {
        this.isReady = true;
      }
    },
    mounted() {
      const permissoes = getUserPermissions();
      this.permissoes = JSON.parse(permissoes).permissions;
    },
    computed: {
      permissions() {

        return this.permissoes;
      },
      isSuperAdmin() {
        const isPermission = this.hasPermission('p-super-admin');
        this.postData();
        return isPermission;
      },
      segmentUsers() {
        const segmentos = [
          'segmento-infantil',
          'segmento-fundamental-i',
          'segmento-fundamental-ii',
          'segmento-ensino-medio',
          'segmento-pre-vestibular',
          'segmento-enem',
          'banco-de-livros'
        ];
        return segmentos.some((permission) => this.hasPermission(permission));
      },
      segmentAdmin() {
        const segmentosADM = ['service24-h', 'service-super-pro', 'bypass', 'list-users'];
        return segmentosADM.some((permission) => this.hasPermission(permission));
      }
    },
    methods: {
      async postData() {
        try {
          const response = await ApiService.get('users/getBoxAllowed');

          this.objectBox = response;
        } catch (error) {
          console.log('Error fetching data: ', error);
        } finally {
          console.log('Request completed');
          this.isLoading = false;
        }
      },
      hasPermission(permissao) {
        return this.permissions.includes(permissao);
      },
      renderBoxes() {
      }
    }
  };
</script>

<style scoped>
  .card_sistemacpv {
    margin-top: 30px;
    border-radius: 8px;
  }
</style>
